/**
 * @description
 * Behavior for a datepicker calendar grid cell button.
 * The aria roles need to be explicitly added so that VPC mode is turned off when navigating the grid.
 * Thus the keyboard navigation works properly.
 * @specification
 * Adds attribute 'aria-selected=true' based on the property 'selected'.
 * Adds role='gridcell'.
 */
export var datepickerCalendarCellButtonBehavior = function datepickerCalendarCellButtonBehavior(props) {
  return {
    attributes: {
      root: Object.assign({
        role: 'gridcell'
      }, props.selected && {
        'aria-selected': true
      }, props.disabled && {
        'aria-disabled': true
      }, props.today && {
        'aria-current': 'date'
      })
    }
  };
};